import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum LandOrder {
    None,
    LanduseDescr,
    StatusDescr,
    Address,
    Town,
    LandCode,
    Area,
    ClientRef
}

export enum LandFilter {
    All
}
